'use client';

// Event name using for trigger open/close login popup
var LOGIN_POPUP = 'LOGIN_POPUP';
// UPDATE_USER event used for dispatch userInfo to other microfrontend pages
var UPDATE_USER = 'UPDATE_USER';
// KEY_AUTH_TOKEN is query params that is passed by mobile from WebView
var KEY_AUTH_TOKEN = 'authtoken';
var WS_TOKEN = 'VNWWS128450527232960';
var JS_TOKEN = 'VNW128450527232960';
var JS_ALL_TOKEN = 'VNWJSAll128450527232960';
var USER_COOKIE = 'VNW_USER_COOKIE';
var WS_COOKIE = 'VNW_WS_COOKIE';
var VNW_NEW_REGISTERED = 'VNW_NEW_REGISTERED';
// VNW_CSRF_JWT_TOKEN in cookie
var VNW_CSRF_JWT_TOKEN = 'VNW_CSRF_JWT_TOKEN';
// response message USER_NOT_ACTIVE
var USER_NOT_ACTIVE_EN = 'You have not verified your email. Please check your email inbox for instruction.';
var USER_NOT_ACTIVE_VI = 'Email của bạn chưa được xác thực. Hãy kiểm tra hộp thư để được hướng dẫn.';
// Response message USER_EMPLOYER
var USER_EMPLOYER_EN = 'This email address is registered as Employer, please Sign in from Employer Site.';
var USER_EMPLOYER_VI = 'Email đăng nhập được đăng ký trên trang nhà tuyển dụng, vui lòng đăng nhập trên trang nhà tuyển dụng.';
// BAN case
var USER_BANNED_EN = 'The account is banned from VietnamWorks. For more information, please contact us via (84 28) 5404 1373.';
var USER_BANNED_VI = 'Tài khoản đã bị chặn truy cập vào VietnamWorks. Để biết thêm chi tiết, vui lòng liên hệ chúng tôi qua (84 28) 5404 1373.';
// PageName (type EPages)
var EPages;
(function (EPages) {
    EPages["HOME_PAGE"] = "homepage";
    EPages["SEARCH_RESULT"] = "searchResult";
    EPages["SEO_LANDING_PAGE"] = "SEOLandingPage";
    EPages["TOP_MANAGEMENT_JOBS"] = "topManagementJobs";
    EPages["INTERVIEW"] = "interview";
    EPages["SALARY"] = "salary";
    EPages["COMPANY_LIST"] = "companyList";
    EPages["JOB_DETAIL"] = "jobDetail";
    EPages["MY_CAREER_CENTER"] = "myCareerCenter";
    EPages["DASHBOARD"] = "dashboard";
    EPages["PROFILE_SETTINGS"] = "profileSettings";
    EPages["MY_COMPANIES"] = "myCompanies";
    EPages["PROFILE_VIEWS"] = "profileViews";
    EPages["MY_JOBS"] = "myJobs";
    EPages["JOB_ALERTS"] = "jobAlerts";
    EPages["MY_PROFILE"] = "myProfile";
    EPages["ACCOUNT_SETTINGS"] = "accountSettings";
    EPages["OTHER"] = "other";
    EPages["MY_ACCOUNT"] = "myAccount";
    EPages["WOW_CV"] = "wowCv";
    EPages["REFERRAL_CANDIDATES"] = "referralCandidates";
    EPages["CAREER_TOOLS"] = "careerTools";
    EPages["SALARY_CONVERTER"] = "salaryConverter";
    EPages["CAREER_PATH"] = "careerPath";
    EPages["NUMEROLOGY"] = "numerology";
    EPages["EMPOWER_GROWTH"] = "empowerGrowth";
    EPages["PROFILE_SETTING"] = "profileSettings";
    EPages["VIEWED_JOBS"] = "viewedJobs";
    EPages["ACCOUNT_SETTING"] = "accountSettings";
    EPages["RECOMMENDED_JOBS"] = "recommendedJobs";
    EPages["APPLIED_JOB"] = "appliedJobs";
    EPages["ORDER_MANAGEMENT"] = "orderMangagement";
})(EPages || (EPages = {}));
var UTM_SOURCE_MAPPING = {
    wowCv: 'WowCv'
};

export { EPages, JS_ALL_TOKEN, JS_TOKEN, KEY_AUTH_TOKEN, LOGIN_POPUP, UPDATE_USER, USER_BANNED_EN, USER_BANNED_VI, USER_COOKIE, USER_EMPLOYER_EN, USER_EMPLOYER_VI, USER_NOT_ACTIVE_EN, USER_NOT_ACTIVE_VI, UTM_SOURCE_MAPPING, VNW_CSRF_JWT_TOKEN, VNW_NEW_REGISTERED, WS_COOKIE, WS_TOKEN };
//# sourceMappingURL=constants.js.map
